import React, { useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";

import AiDraftAssistant, { assistantLabels } from "../../components/AiDraftAssistant";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const SUGGESTION_KEYS = ["s1", "s2", "s3", "s4"];

const ManualKnowledgeDialog = ({ open, onClose, onSaved, initialName = "", initialText = "", lockName = false }) => {
  const [name, setName] = useState(initialName);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setName(initialName);
  }, [open, initialName]);

  const ask = async body => (await api.post("/knowledge/assistant", body)).data;

  const uploadSource = async file => {
    const body = new FormData();
    body.append("file", file);
    return (await api.post("/knowledge/assistant/source", body)).data;
  };

  const fillName = ({ typed, source }) => {
    if (!lockName && !name.trim()) setName(typed || source.name.replace(/\.[^.]+$/, ""));
  };

  const save = async text => {
    setSaving(true);
    try {
      const { data } = await api.post("/knowledge/manual", { name: name.trim(), text });
      onSaved(data);
    } catch (err) {
      toastError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <AiDraftAssistant
      open={open}
      onClose={onClose}
      title={i18n.t(lockName ? "knowledge.manual.editTitle" : "knowledge.manual.title")}
      initialText={initialText}
      externalBusy={saving}
      labels={assistantLabels("knowledge.manual", {
        attachSource: i18n.t("knowledge.manual.attachSource"),
        sourceGoal: sourceName => i18n.t("knowledge.manual.sourceGoal", { name: sourceName }),
        sourceTruncated: sourceName => i18n.t("knowledge.manual.sourceTruncated", { name: sourceName })
      })}
      suggestions={SUGGESTION_KEYS.map(key => i18n.t(`knowledge.manual.suggestions.${key}`))}
      onAsk={ask}
      onUploadSource={uploadSource}
      onStart={fillName}
      topBarContent={({ text, busy }) => (
        <>
          <TextField
            placeholder={i18n.t("knowledge.manual.namePlaceholder")}
            value={name}
            onChange={e => setName(e.target.value)}
            disabled={lockName}
            size="small"
            style={{ width: 360, maxWidth: "100%" }}
          />
          <span style={{ flex: 1 }} />
          <Button variant="contained" onClick={() => save(text)} disabled={busy || !name.trim() || !text.trim()}>
            {saving ? i18n.t("knowledge.manual.saving") : i18n.t("knowledge.manual.save")}
          </Button>
        </>
      )}
    />
  );
};

export default ManualKnowledgeDialog;
